import { ReactNode } from 'react'
import { CellProps } from 'react-table'
import { isNotNullable } from '@rw1/utilities/type'

type TBaseType =
  | Date
  | Record<string, unknown>
  | number
  | string
  | null
  | undefined

/**
 * `applyCell` applies a cell in a safe way.
 * If the underlying value is falsy, it will render `null`, so that users can rely on always receiving truthy values
 * @param cell
 */
export const applyCell =
  <CellType extends TBaseType>(cell?: (arg: CellType) => ReactNode) =>
    (obj: CellProps<Record<string, unknown>>): ReactNode => {
      const renderCell = isNotNullable(cell)
        ? cell(obj.value)
        : obj.value.cell(obj.value.value)

      return obj.value ? renderCell : null
    }

/**
 * `applyNullableCell` applies a cell regardless of the presence of an underlying value.
 * Useful if the cell is designed to handle falsy values itself.
 * @param cell
 */
export const applyNullableCell =
  <CellType extends TBaseType>(cell: (arg: CellType) => ReactNode) =>
    (obj: CellProps<Record<string, unknown>>): ReactNode =>
      cell(obj.value)
